import { render, staticRenderFns } from "./NamedGroup.vue?vue&type=template&id=195bb4ad&scoped=true&"
import script from "./NamedGroup.vue?vue&type=script&lang=js&"
export * from "./NamedGroup.vue?vue&type=script&lang=js&"
import style0 from "./NamedGroup.vue?vue&type=style&index=0&id=195bb4ad&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195bb4ad",
  null
  
)

export default component.exports